type Props = {
  width?: number,
  height?: number,
  fill?: string,
  className?: string,
}

const SlightCurve = ({ width = 10, height = 63, fill = '#EB48A0', className }: Props) =>
  <svg width={width} height={height} fill='none' viewBox='0 0 10 63' className={className}>
    <path d='M2.99496 2.98704C7.41399 17.715 9.18046 38.9124 3.16278 60.3161' stroke={ fill } strokeWidth='4' strokeLinecap='round'/>
  </svg>

export default SlightCurve
